<template> 
    <div class="verify">
      <LoadingIndicator message="Verifying Email" v-if="isLoading"/>
    </div>
    <ConfirmationMessageModal :title="title" :body="body" :button-label="buttonLabel" :close-modal="() => backToHome()"/>
</template>
<script>
import { verifyEmailAsync } from '@/services/authService';
import LoadingIndicator from '@/components/Utility/LoadingIndicator.vue';
import ConfirmationMessageModal from '@/components/modals/ConfirmationMessageModal.vue';
import Modal from 'bootstrap/js/dist/modal'

export default {
  data(){
    return{
      isLoading: true,
      body:"",
      title:"",
      buttonLabel:"",
      confirmModal: null
    }
  },
    components:{
        LoadingIndicator, ConfirmationMessageModal
    },
    async mounted(){

    setTimeout(async() => {
    this.confirmModal = new Modal(document.getElementById('confirmMessageModal'));
    const userId = this.$route.query.userId
    const token = this.$route.query.token

    try {
       const data = await verifyEmailAsync(userId,token);
       this.isLoading = false;
       if(!data.success){
        throw new Exception(data.message,{cause: data.caption})
       }
       this.$router.push({path:'/login',
              query:{
                message:"Your Email Address has been verified. You can log in"
              }
      });
    }catch(e){
      this.body = e.message || "Something went wrong. Unable to verify Email";
      this.title = e.cause || "Email verification failed";
      this.confirmModal.show();
    }
  }, 5000); //artifical delay of 5 secs

  },
  methods:{
    backToHome(){
      this.confirmModal.hide();
      this.$router.push('/login');
    }
  }

}
</script>
<style scoped>
    .verify{
        background-color:white;
        height:100vh;
        display:flex;
        align-items: center;
        justify-content: center;
    }

   
</style>